import React from 'react';
import { useSelector } from 'react-redux';
import TrailDashboard from '../TrailDashboard';
import WCANewTemplate from '../WCA/WCAMessageTemplate/NewTemplate';
import NewTemplate from '../MessageTemplates/NewTemplate';

const NewCampaignTemplate = () => {
  const { userSub, companyConfigData } = useSelector((state) => state.authenticate);
  if (!userSub?.isUserSub) {
    return <TrailDashboard />;
  }

  return companyConfigData?.wabaPartner === 'skalebot' ? <WCANewTemplate /> : <NewTemplate />;
};

export default NewCampaignTemplate;
